import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { getCookie } from '../data/utils/cookie-utils';

export const authGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const token = getCookie('access_token');

  if (!token || token === undefined) {
    //  Save return URL before redirect
    localStorage.setItem('return_url', state.url);

    router.navigate(['/']);
    return false;
  } else {
    //  Token valid, remove saved data if any
    localStorage.removeItem('return_url');
    return true;
  }
};
;
